export default {
  common: {
    getDataFailed: '데이터를 가져오기 실',
    cancel: '취소',
    noResult: '결과 없음',
    prize: '상',
    totalPrize: '총상금',
    round: '라운드',
    time: '시간',
    address: '주소',
    options: '옵션',
    type: '타입',
    none: '없음',
    executedSuccessfully: '성공적으로 실행',
    point: '포인트',
    points: '포인트',
  },
  header: {
    referral: '추천',
    connect: '연결',
    records: '내 기록',
    register: '지불/스테이킹',
    disconnect: '연결 끊기',
    networkHint: '네트워크 지연에 주의하십시오',
  },
  rules: {
    top: '도전할 준비가 되셨나요? 한 라운드에 총 12개의 질문이 있으며, 우승자는 최소 $10,000 USDT 상금 풀을 공유할 수 있습니다.',
    title: '규칙',
    section1: '등록 마감일은 오전 09:00 GMT(한국시간 저녁 9시)이며, 이벤트는 오후 09:05 GMT(한국시간 저녁 9시 5분)에 시작됩니다.',
    section2: "이 이벤트에 참여하려면 하나의 Lifeform Cartoon아바타를 스테이킹 하시고 추가로 500 Points를 지불하거나 20 USDT를 지불해야 합니다.",
    section3: '총 12 개의 질문. 한 질문에 대해 답변을 선택하는 데 20 초가 있으며 나머지 5 초 동안 정답이 표시됩니다. 당신이 정답이 맞다면 다음 질문으로 넘어갑니다.',
    section4: '이 라운드가 끝나면 아바타를 언스테이킹할 수 있습니다.',
    section5: '상품은 각 라운드가 끝난 후 우승자에게 에어드랍됩니다.',
    section6: '친구에게 추천 링크를 보내 부활 카드를 받으세요. [그 / 그녀가 당신의 링크를 사용하고 SuperAvatar 이벤트에 가입하면 당신은 부활카드를 얻을 수 있습니다.]',
    section7: '당신은 부활 카드를 사용하여 라운드를 계속할 수 있습니다. 부활 카드 1장은 라운드당 1번의 기회만을 위한 것입니다.',
    section8: '사용하지 않은 부활 카드는 매 라운드 후 자동으로 무효화됩니다.',
  },
  home: {
    prizePool: '상금 풀',
    totalParticipants: '총 참가자 수',
    round: '라운드 ',
    startIn: '에서 시작',
    connect: '연결',
    register: '가입',
    registered: '가입 완료',
    enter: '게임 시작',
    ongoing: '진행 중',
    ended: '게임 종료',
    cumulativeRanking: '누적 순위',
  },
  register: {
    registerRecords: '가입 기록',
    registerForRound: '라운드 등록',
    youCanChoose: '당신은 선택할 수 있습니다',
    pay: '지불',
    or: '또는',
    stake: '스테이킹',
    staked: '가 스테이킹 되었습니다',
    paid: '가 지불되었습니다',
    inviteFriends: '친구 초대',
    insufficientFunds: '잔금 부족',
    registerSuccess: '등록에 성공했습니다',
    registerFail: '등록에 실패했습니다',
    onceRegistered: '등록성공 후 이번 라운드에서 Lifeform Cartoon 메달을 받을 수 있습니다.',
    checkMyMedal: '내 메달 확인',
    backToHome: '첫 페이지로 돌아가기',
    pointsNotEnough: '포인트 부족',
  },
  records: {
    myTotalPrize: '나의 총상금',
    myRecordsInSuperAvatar: '나의 super avatar 기록',
    round: '라운드',
    totalRegistered: '총 참가자 수',
    totalPrize: '총상금',
    winners: '우승자',
    defeat: '패배',
    myPrize: '나의 상금',
    myRecordsOfPayStake: '나의 지불/스테이킹 기록',
    checkStage1: 'Super Avatar I 확인하기',
    backToStage2: 'Super Avatar II로 돌아가기',
  },
  share: {
    share: '공유',
    referralUrlCopied: '초대 URL이 복사 완료',
    showItOff: '자랑하기',
    invitingYouTo: '가 당신을 초대합니다',
    theWinnersTakeAll: '수상자 소유 공유',
    yourReferralUrl: '추천 URL',
    downloadAndShare: '사진 다운로드 및 공유',
    comeToWin: '슈퍼 아바타에 와서 상금을 받으세요!',
    iHaveDefeated: '나는 플레이어의',
    ofThePlayers1: '를 ',
    ofThePlayers2: '이겼고 거의',
    isTheWinnerOfThisRound: '가 이번 라운드의 우승자입니다.',
    hasWon: '승리했다',
    comeToTogether: '함께 더 많은 상금을 받으세요',
    hereRecordOf: '의 게임 기록입니다',
    knowMore: '슈퍼 아바타에 대해 더 많이 알기',
    iHaveWon: '내가 이겼어',
    everyDay: '매일',
    resurrectionCardUsed: '부활 카드 사용',
    everyDay12GMTAAnswer: '매일 오후 9시(GMT)에 12개의 질문에 답하고 즉시 10000 USDT를 균등하게 공유하세요. 링크에 참여하십시오:',
    totalHighAs: '총상금',
    everyDay12GMT: '매일 오후 9시(GMT)',
    answer12Today1: '12개의 질문에 정답을 맞히면 당첨자는',
    answer12Today2: '오늘의 모든 상품을 균등하게 공유합니다.',
    numIHaveDefeated: '',
    numOfThePlayers1: '명의 플레이어를 ',
    numOfThePlayers2: '이기고 거의',
    holdDownShare: '사진을 길게 눌러 공유',
    win: '이기다',
  },
  stake: {
    registerByStaking: '스테이킹으로 등록하기',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: '아바타 선택',
    stake: '스테이킹',
    unstake: '언스테이킹',
    unstaked: '언스테이킹',
    approveToken: '가입을 위하여 토큰 권한을 승인하십시오',
    approveNFT: '스테이킹을 하기 위하여 NFT 권한을 승인하십시오',
  },
  match: {
    watching: '시청 중',
    sorryYouAreOut: '죄송합니다, 당신은 아웃 되었습니다!',
    wishNext: '다음 게임에서 승리하시길 바랍니다!',
    totalPrize: '총상금',
    survivedAndTotal: '생존/총 참가자 수',
    prizeForEach: '각각에 대한 상금',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: '축하!',
    areWinner: '당신은 이 라운드의 우승자입니다.',
    almostWinner: '당신은 거의 승자입니다!',
    keepLearning: '계속 배우고 다음 라운드에서 승리하세요!',
    toGetCard: '다음 라운드를 위한 부활 카드를 얻기',
  },
  referral: {
    currentRound1: '지금은',
    currentRound2: '라운드입니다',
    inviteYourFriendsTo: '이번 라운드에서 부활 카드를 받도록 친구를 초대하기!',
    referralRecords: '추천 기록',
    round: '라운드',
    resurrectionCard: '부활 카드',
    usedOrNot: '사용 여부',
    invitedUsers: '초대된 사용자',
    used: '사용',
    unused: '미사용',
    none: '없음',
    viewDetails: '세부 정보 보기',
  },
};